<template>
    <div
        class="l-ss-c-results-empty-section"
        :class="{ 'l-ss-c-results-empty-section-with-offers': popularOffers.length }">
        <section-results-info
            :search="search"
            :show-autocomplete-elements="false"
            @autocomplete-search="$emit('autocomplete-search', $event)"/>
        <ul
            class="l-ss-c-results-empty-section-tags"
            v-if="popularQueries.length">
            <li
                v-for="(tag, index) in popularQueries"
                :key="`popular-query-tag-${index}`"
                class="l-ss-c-results-empty-section-tag"
                @click="$emit('handle-tags-click', tag.text.value)">
                {{ tag.text.value }}
            </li>
        </ul>

        <div
            class="l-ss-c-results-empty-offers-wrapper"
            :class="{ 'l-ss-c-results-empty-offers-wrapper-mobile': $screen.isMobile }"
            v-if="popularOffers.length">
            <div class="l-ss-c-results-empty-offers-title">{{ $t('results.popularOffers') }}</div>
            <offers-wrapper
                view="grid"
                :key="offerLayout"
                :offer-layout="offerLayout"
                :breakpoint="{ columnCount: 2, gridGap: 24 }"
                :offers="popularOffers"
                @add-to-cart-click="params => $emit('add-to-cart-click', params)"
                @remove-from-cart-click="params => $emit('remove-from-cart-click', params)"
                @add-to-favourites-click="params => $emit('add-to-favourites-click', params)"
                @remove-from-favourites-click="params => $emit('remove-from-favourites-click', params)"/>
        </div>
    </div>
</template>

<script>
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import OffersWrapper from '@/core/components/offers-wrapper.vue';

    export default {
        components: { OffersWrapper, SectionResultsInfo },
        props: {
            search: {
                type: Object,
            },
            popularQueries: {
                type: Array,
                default: () => [],
            },
            configuration: {
                type: Object,
            },
            popularOffers: {
                type: Array,
            },
            isLeftSectionVisible: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            offerLayout() {
                return this.isLeftSectionVisible || this.$screen.isMobile
                    ? 'columnMini'
                    : 'rowMini';
            },
        },
    };
</script>

<style scoped>

</style>
